/**
 * Format a coordinate in mm to meters with 2 decimals.
 */
export const formatCoord = (n: number | undefined) =>
  typeof n === 'number' ? (n / 1000).toFixed(2).replace('.', ',') : '';
